function SeventhPage (){
    return(
        <div className="w-4/5 mx-auto mt-32">
            <div className="flex flex-col gap-5 items-center">
                <h2 className="max-w-[45rem] text-4xl sm:text-5xl font-extrabold sm:leading-tight text-white text-center">Recieve transmissions</h2>
                <p className="text-gray-500">Unsubscribe at any time <span className="text-white text-xs sm:text-base">Privacy Policy ➚</span></p>
                <input placeholder="Email Address" className="px-6 py-3 border border-gradient-to-tr from-[#933FFE] to-[#18C8FF] bg-gray-950 rounded-lg "></input>
            </div>
        </div>
    )
}

export default SeventhPage